import bcrypt from 'bcryptjs';
import { idbGet, idbPut, STORES } from './idb';
import { updateCounterFromServer } from './inspectionCode';

// ملف المستخدمين على الجهاز: يُنزَّل من الخادم مع كل دخول وفتح للتطبيق بالوضع أونلاين،
// ويتيح لأي مستخدم فيه تسجيل الدخول دون اتصال. يحمل بصمة كلمة المرور (bcrypt) لا كلمة المرور،
// ومزادات كل مستخدم (لقائمة المزادات في شاشة الدخول)، وآخر رقم فحص له في كل مزاد.
const FILE_KEY = 'users-file';

// جلسة دخول من الملف بلا توكن من الخادم: تكفي للعمل والإدخال على الجهاز،
// وعند الرجوع إلى «أونلاين» يسجّل المستخدم دخوله مع الاتصال ثم تُرفع فحوصاته.
export const OFFLINE_SESSION_TOKEN = 'offline-session';

export async function saveUsersFile(file) {
  if (!Array.isArray(file?.users)) return;
  await idbPut(STORES.kv, { generated_at: file.generated_at, saved_at: new Date().toISOString(), users: file.users }, FILE_KEY);
}

export async function readUsersFile() {
  try {
    return await idbGet(STORES.kv, FILE_KEY);
  } catch {
    return null;
  }
}

async function findUser(username) {
  const name = String(username || '').trim().toLowerCase();
  if (!name) return null;
  const file = await readUsersFile();
  return (file?.users || []).find((user) => (
    String(user.username || '').toLowerCase() === name || String(user.email || '').toLowerCase() === name
  )) || null;
}

export async function usersFileAuctions(username) {
  const user = await findUser(username);
  return (user?.auctions || []).map((auction) => ({ id: auction.id, name: auction.name }));
}

// يعيد بيانات المستخدم بشكل /auth/user، أو يرمي خطأ برسالة واضحة.
export async function loginWithUsersFile(username, password, auctionId = null) {
  const user = await findUser(username);
  if (!user) {
    const error = new Error('هذا المستخدم غير موجود في ملف المستخدمين على الجهاز. سجّل الدخول مرة بالوضع أونلاين لتحديث الملف.');
    error.unknownUser = true;
    throw error;
  }

  const matches = await bcrypt.compare(String(password), String(user.password_hash || ''));
  if (!matches) {
    const error = new Error('بيانات الدخول غير صحيحة');
    error.invalidCredentials = true;
    throw error;
  }

  const auctions = user.auctions || [];
  const chosen = auctionId
    ? auctions.find((auction) => Number(auction.id) === Number(auctionId))
    : (auctions.length === 1 ? auctions[0] : null);
  if (!chosen) {
    throw new Error('اختر المزاد.');
  }

  // آخر رقم فحص للمستخدم في المزاد، ليكمل الجهاز التسلسل الصحيح دون اتصال.
  await updateCounterFromServer({ auction_id: chosen.id, user_id: user.id, last_seq: user.counters?.[chosen.id] || 0 });

  const { password_hash: ignoredHash, counters: ignoredCounters, ...profile } = user;
  return {
    ...profile,
    auction: chosen,
    branch: chosen,
    selected_auction_id: Number(chosen.id),
    requires_auction_selection: false,
    offline_session: true,
  };
}
